<app-share-button ></app-share-button>

<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>
                        Introduction </h2>
                </div>
                <!-- <div class="col-md-2 col2"><button class="btn share"><img src="./assets/share (5).svg"
                            style="width: 30px;" alt=""></button>
                </div> -->
                <div class="col-md-2 col2 "> <a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="1">

                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="2">
                    <h2>Introduction to Sales Partner</h2>
                    <label for="" class="mt-2">In the ever-changing world of business, Sales Partners play an important role
                        in the distribution chain. This document aims to provide a detailed overview of what a Sales Partner
                        is, the benefits they offer, and how they can make the most of their position for maximum
                        profitability and growth, particularly in the PayG sector. </label>
                </div>
                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="3">
                    <h2>What is a Sales Partner? </h2>
                    <label for="" class="mt-3">A Sales Partner is a business or individual that purchases products or
                        services from a manufacturer or distributor intending to sell them to end customers. Sales Partners
                        can operate in various sectors, including technology, consumer goods, and financial services.
                        They often add value through additional services such as customer support, training, and
                        customization. </label>


                    <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                        id="4">
                        <h2>
                            Benefits of Being a Sales Partner
                        </h2>


                        <h4 class="mt-4"><b>1. Low Overhead Costs:</b></h4>
                        <label for="">Sales Partners can operate with minimal investment compared to starting a business from
                            scratch. They do not need to invest heavily in manufacturing or product development.</label>

                        <h4 class="mt-4"><b>2. Access to Established Products:</b></h4>
                        <label for="">Sales Partners can offer products and services that are already market-tested, reducing
                            the risks associated with launching new offerings</label>

                        <h4 class="mt-4"><b>3. Flexibility and Scalability:</b></h4>
                        <label for="">Sales Partners can quickly adapt their inventory and offerings based on market demand,
                            allowing them to scale their operations effectively.</label>

                        <h4 class="mt-4"><b>4. Diverse Revenue Streams:</b></h4>
                        <label for="">By partnering with multiple suppliers, Sales Partners can diversify their product lines
                            and income sources, reducing dependency on a single product or supplier. </label>

                        <h4 class="mt-4"><b>5. Networking Opportunities:</b></h4>
                        <label for="">Working with multiple vendors and clients allows Sales Partners to build valuable
                            relationships, enhancing their market presence and business prospects. </label>

                        <h4 class="mt-4"><b> 6. Market Knowledge:</b></h4>
                        <label for="">Sales Partners often gain insights into consumer preferences and trends, which can
                            inform their purchasing and sales strategies. </label>
                    </div>

                    <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')"
                        id="5">
                        <h2> How Sales Partners Can Benefit from PayG </h2>
                        <label for="">In the PayG landscape, Sales Partners have unique opportunities to capitalize on
                            technology-driven innovations. Here’s how they can benefit: </label>

                        <h4 class="mt-4"><b> 1. Enhanced Product Offering </b></h4>
                        <label for="">By partnering with PayG, Sales Partners can offer advanced financial products such as
                            payment processing solutions, lending platforms, and accounting software. This can attract
                            new customers and retain existing ones. </label>

                        <h4 class="mt-4"><b>2. Improved Customer Experience </b></h4>
                        <label for="">Utilizing PayG solutions can streamline operations, improve transaction speeds,
                            and enhance customer support, leading to a better overall experience for end-users. </label>


                        <h4 class="mt-4"><b>3. Competitive Advantage </b></h4>
                        <label for="">Sales Partners that adopt innovative PayG solutions can differentiate themselves in a
                            crowded market, providing unique value propositions that resonate with customers. </label>


                        <h4 class="mt-4"><b> 4. Training and Support </b></h4>
                        <label for="">PayG often provide training and support for their Sales Partners, equipping them with
                            the knowledge needed to effectively market and sell products.</label>


                        <h4 class="mt-4"><b> 5. Increased Profit Margins </b></h4>
                        <label for="">By incorporating PayG solutions, Sales Partners can optimize their operations, reduce
                            costs, and potentially increase their profit margins through value-added services. </label>
                    </div>

                    <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'6')" (mouseout)="showpayment(false,'6')"
                        id="6">
                        <h2> Best Practices for Sales Partners </h2>


                        <h4 class="mt-4"><b> 1. Understand Your Market: </b></h4>
                        <label for="">Conduct thorough research to identify customer needs and market trends. This will
                            help tailor your offerings to meet demand. </label>

                        <h4 class="mt-4"><b>2. Build Strong Relationships: </b></h4>
                        <label for="">Cultivate relationships with PayG and clients. Strong partnerships can lead to
                            better pricing, exclusive products, and collaborative marketing opportunities. </label>


                        <h4 class="mt-4"><b>3. Leverage Technology: </b></h4>
                        <label for="">Utilize digital marketing tools, and data analytics to enhance sales strategies
                            and customer engagement. </label>


                        <h4 class="mt-4"><b>4. Stay Informed: </b></h4>
                        <label for="">Keep ahead of the latest developments in PayG to remain competitive. </label>


                        <h4 class="mt-4"><b>5. Focus on Customer Support: </b></h4>
                        <label for="">Providing exceptional customer service can differentiate your business and foster
                            long-term loyalty among clients </label>



                    </div>
                    <p>For more information, resources, or assistance, please feel free to reach out to our support
                        team. </p>


                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span class="videoHover" style="cursor: pointer;"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                    >
                                    Introduction to
                                    Payment Gateways
                                </span>
                              
                            </div>
                        </div>
                    </a> -->
                </div>
                <div class="col-md-12 ">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')">Introduction to Sales Partner </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">
                                    What is a Sales Partner? </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">Benefits of Being a Sales Partner </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#5">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('5')"> How Sales Partners Can Benefit from PayG</span>

                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-md-12 ">
                    <a href="#6">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='6'}"
                                    (click)="color('6')">  Best Practices for Sales Partners</span>

                            </div>
                        </div>
                    </a>
                </div>

            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/merchant-dashboard']"><button class="btn btn-color"
                        (click)="menues('Creating Profile')"> <img src="./assets/Arrow 3.svg" alt=""> &nbsp;Merchant
                        Dashboard
                        &nbsp;</button></a>
            </div>
            <div class="col-md-4    ">
                <a [routerLink]="['/registration-process']"> <button class="btn btn-color">Registration process
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
</div>